// # 引用 Element-plus 库
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import * as Elicons from "@element-plus/icons-vue"
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'

// # 导入公共修改样式
import './root.css'
import './transition.css'
import './aside.css'

// # 引用路由
import router from './router'

// # 最后引用，不然会出现无法重写 css 样式
import { createApp } from 'vue'
import App from './App'
import store from './store/index'
import global from './global'
import qrcodeVue from 'qrcode.vue'

// # 创建应用
const app = createApp(App)
// # 激活引用对象
app.use(ElementPlus, { locale: zhCn})
app.use(store)
app.use(router)

app.component('qrcode-vue', qrcodeVue)

for (const name in Elicons) {
  app.component(name, Elicons[name])
}
global(app);

// # 挂载
app.mount('#app')